// import React, { useState, useEffect } from "react";
// import { assetPermissions as initialAssetPermissions } from "../../../core/json/AssetPermissions";
// import { rolesUsers } from "../../../core/json/rolesUsers";
// import { permissionTypes } from "../../../core/json/permissionType";
// import { rolePermissionDefaults } from "../../../core/json/rolepermissiondefaults"; // new JSON
// import { API_BASE_FILTER_URL } from "../Config/Config";
// const AssetPermissions = () => {
//   // const storedRoleId = sessionStorage.getItem("selectedRole");
//   const [selectedRole, setSelectedRole] = useState("Admin");
//   const [permissions, setPermissions] = useState({});

//   // Initialize default structure

//   useEffect(() => {
//   // Call /getRolePermissions once when component mounts
//   const checkGetRolePermissions = async () => {
//     try {
//       const res = await fetch(`${API_BASE_FILTER_URL}/getRolePermissions`);
//       console.log("Called /getRolePermissions, response status:", res.status);
//       if (res.ok) {
//         const data = await res.json();
//         console.log("getRolePermissions JSON response:", data);
//       } else {
//         console.error("Error response from /getRolePermissions:", res.statusText);
//       }
//     } catch (err) {
//       console.error("Network error calling /getRolePermissions:", err);
//     }
//   };

//   checkGetRolePermissions();
// }, []);


//   useEffect(() => {
//     const initialized = {};
//     initialAssetPermissions.forEach((item) => {
//       initialized[item.id] = {};
//       permissionTypes.forEach((perm) => {
//         initialized[item.id][perm.id] = item.permissions?.[perm.key] || false;
//       });
//     });
//     setPermissions(initialized);
//   }, []);

//   // Update permissions based on selected role
//   useEffect(() => {
//     if (selectedRole && rolePermissionDefaults[selectedRole]) {
//       const updated = {};
//       initialAssetPermissions.forEach((item) => {
//         updated[item.id] = {};
//         permissionTypes.forEach((perm) => {
//           updated[item.id][perm.id] =
//             rolePermissionDefaults[selectedRole]?.[item.operation]?.[perm.id] ||
//             false;
//         });
//       });
//       setPermissions(updated);
//     }
//   }, [selectedRole]);

//   useEffect(() => {
//     if (selectedRole && rolePermissionDefaults[selectedRole]) {
//       const updated = {};
//       initialAssetPermissions.forEach((item) => {
//         updated[item.id] = {};
//         permissionTypes.forEach((perm) => {
//           updated[item.id][perm.id] =
//             rolePermissionDefaults[selectedRole]?.[item.operation]?.[perm.id] ||
//             false;
//         });
//       });
//       setPermissions(updated);
//     }
//   }, []);

//   const handleCheckboxChange = (operationId, permId) => {
//     const updated = { ...permissions };
//     updated[operationId][permId] = !updated[operationId][permId];

//     // Hierarchy logic
//     if (permId === 1 && !updated[operationId][1]) {
//       updated[operationId][2] = false;
//       updated[operationId][3] = false;
//     }
//     if (permId === 2) {
//       if (updated[operationId][2]) updated[operationId][1] = true;
//       else updated[operationId][3] = false;
//     }
//     if (permId === 3 && updated[operationId][3]) {
//       updated[operationId][1] = true;
//       updated[operationId][2] = true;
//     }

//     setPermissions(updated);
//   };

//   const handleAllowAllCheckbox = (operationId, isChecked) => {
//     const updated = { ...permissions };
//     permissionTypes.forEach((perm) => {
//       updated[operationId][perm.id] = isChecked;
//     });
//     setPermissions(updated);
//   };

//   const handleSavePermissions = () => {
 

//     const payload = {
//       role: selectedRole,
//       permissions: Object.entries(permissions).map(([opId, permMap]) => ({
//         operationId: Number(opId),
//         permissionTypeIds: Object.entries(permMap)
//           .filter(([, val]) => val)
//           .map(([id]) => Number(id)),
//       })),
//     };

//     console.log("Permission Payload:", payload);
//     alert(JSON.stringify(payload, null, 2));
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header">
//           <div className="add-item d-flex">
//             <div className="page-title">
//               <h4>Role Permissions</h4>
//               <h6>Manage your permissions</h6>
//             </div>
//           </div>
//         </div>

//         <div className="card table-list-card">
//           <div className="card-body">
//             <div className="table-top mb-0 pt-1">
//               <div className="search-set">
//                 <div className="search-input">
//                   <a href="#" className="btn btn-searchset">
//                     <i className="ti ti-search fs-14 feather-search" />
//                   </a>
//                   <div
//                     id="DataTables_Table_0_filter"
//                     className="dataTables_filter"
//                   >
//                     <label>
//                       <input
//                         type="search"
//                         className="form-control form-control-sm"
//                         placeholder="Search"
//                         aria-controls="DataTables_Table_0"
//                       />
//                     </label>
//                   </div>
//                 </div>
//               </div>
//               <div className="d-flex ">
//                 <div className="row mb-3">
//                   <div className="col">
//                     <label>Role:</label>
//                     <select
//                       className="form-select"
//                       value={selectedRole}
//                       onChange={(e) => {
//                         setSelectedRole(e.target.value);
//                         // setSelectedUser(""); // reset user when role changes
//                       }}
//                     >
//                       {rolesUsers?.roles.map((role) => (
//                         <option key={role} value={role}>
//                           {role}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

                 
//                 </div>
//                 {/* <p className="mb-0 fw-medium text-gray-9 me-1">Role:</p> */}
//               </div>
//             </div>
//             <table className="table datatable">
//               <thead className="thead-light">
//                 <tr>
//                   <th>Menu</th>
//                   <th>Operation</th>
//                   {permissionTypes.map((perm) => (
//                     <th key={perm.id}>{perm.label}</th>
//                   ))}
//                   <th>Allow All</th> {/* New column */}
//                 </tr>
//               </thead>
//               <tbody>
//                 {initialAssetPermissions.map((item) => {
//                   const allChecked = permissionTypes.every(
//                     (perm) => permissions[item.id]?.[perm.id]
//                   );

//                   return (
//                     <tr key={item.id}>
//                       <td>{item.menu}</td>
//                       <td>{item.operation}</td>
//                       {permissionTypes.map((perm) => (
//                         <td key={perm.id}>
//                           <div className="form-check form-check-md">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               disabled
//                               checked={permissions[item.id]?.[perm.id] || false}
//                               onChange={() =>
//                                 handleCheckboxChange(item.id, perm.id)
//                               }
//                             />
//                           </div>
//                         </td>
//                       ))}
//                       <td>
//                         <div className="form-check form-check-md">
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             checked={allChecked}
//                             disabled
//                             onChange={(e) =>
//                               handleAllowAllCheckbox(item.id, e.target.checked)
//                             }
//                           />
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>

//             <div className="text-end mt-3">
//               <button
//                 className="btn btn-primary"
//                 onClick={handleSavePermissions}
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AssetPermissions;


import React, { useState, useEffect } from "react";
import { Spin } from "antd"; // Import Spin from antd
import { rolePermissionDefaults } from "../../../core/json/rolepermissiondefaults";
import { getApiBaseUrl } from "../Config/Config";

const AssetPermissions = () => {
  const roleIdMap = {
    Admin: 2,
    Approver: 3,
    Supervisor: 4,
    Operator: 5,
  };

  const permissionTypes = [
    { id: 1, label: "Read", key: "Read" },
    { id: 2, label: "Write", key: "Write" },
    { id: 3, label: "Delete", key: "Delete" },
    { id: 4, label: "Export", key: "Export" },
  ];

  const [selectedRole, setSelectedRole] = useState("Admin");
  const [permissions, setPermissions] = useState({});
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(false); 

  // Fetch role menu data from API
  useEffect(() => {
    const fetchRoleMenu = async () => {
      const roleId = roleIdMap[selectedRole];
      if (!roleId) return;

      setLoading(true); 
      try {
        const res = await fetch(`${getApiBaseUrl()}/api/getRoleMenu?RoleId=${roleId}`);
        console.log("Called /getRoleMenu, response status:", res.status);
        if (res.ok) {
          const data = await res.json();
          console.log("getRoleMenu JSON response:", data);
          const transformedData = data.ResultData.map((item) => ({
            id: item.RoleMenuid,
            menu: item.MenuName,
            operation: item.MenuPath,
            permissions: {
              Read: item.Read,
              Write: item.Write,
              Delete: item.Delete,
              Export: item.Export,
            },
          }));
          setMenuData(transformedData || []);
        } else {
          console.error("Error response from /getRoleMenu:", res.statusText);
        }
      } catch (err) {
        console.error("Network error calling /getRoleMenu:", err);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchRoleMenu();
  }, [selectedRole]);

  // Initialize permissions based on fetched menu data
  useEffect(() => {
    const initialized = {};
    menuData.forEach((item) => {
      initialized[item.id] = {};
      permissionTypes.forEach((perm) => {
        initialized[item.id][perm.id] = item.permissions?.[perm.key] || false;
      });
    });
    setPermissions(initialized);
  }, [menuData]);

  // Update permissions based on selected role and defaults
  useEffect(() => {
    if (selectedRole && rolePermissionDefaults[selectedRole]) {
      const updated = {};
      menuData.forEach((item) => {
        updated[item.id] = {};
        permissionTypes.forEach((perm) => {
          updated[item.id][perm.id] =
            rolePermissionDefaults[selectedRole]?.[item.operation]?.[perm.id] ||
            item.permissions?.[perm.key] ||
            false;
        });
      });
      setPermissions(updated);
    }
  }, [selectedRole, menuData]);

  const handleCheckboxChange = (operationId, permId) => {
    const updated = { ...permissions };
    updated[operationId][permId] = !updated[operationId][permId];

    // Hierarchy logic
    if (permId === 1 && !updated[operationId][1]) {
      updated[operationId][2] = false;
      updated[operationId][3] = false;
    }
    if (permId === 2) {
      if (updated[operationId][2]) updated[operationId][1] = true;
      else updated[operationId][3] = false;
    }
    if (permId === 3 && updated[operationId][3]) {
      updated[operationId][1] = true;
      updated[operationId][2] = true;
    }

    setPermissions(updated);
    updatePermissions(operationId, updated[operationId]);
  };

  const handleAllowAllCheckbox = (operationId, isChecked) => {
    const updated = { ...permissions };
    permissionTypes.forEach((perm) => {
      updated[operationId][perm.id] = isChecked;
    });
    setPermissions(updated);
    updatePermissions(operationId, updated[operationId]);
  };

  const updatePermissions = async (operationId, permMap) => {
    const userData = JSON.parse(sessionStorage.getItem("user"));
    console.log("eeeeeee", userData?.UserID);
    const userId = userData?.UserID;
    const payload = {
      RoleMenuid: Number(operationId),
      Read: permMap[1] ? 1 : 0,
      Write: permMap[2] ? 1 : 0,
      Delete: permMap[3] ? 1 : 0,
      Export: permMap[4] ? 1 : 0,
      UpdatedBy: Number(userId),
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/api/updateRoleMenu`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      console.log("Called /updateRoleMenu, response status:", res.status);
      if (res.ok) {
        console.log("Permissions updated successfully for RoleMenuid:", operationId);
      } else {
        console.error("Error response from /updateRoleMenu:", res.statusText);
      }
    } catch (err) {
      console.error("Network error calling /updateRoleMenu:", err);
    }
  };

  // const handleSavePermissions = () => {
  //   console.log("All permissions saved");
  //   alert("Permissions have been saved successfully!");
  // };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Role Permissions</h4>
              <h6>Manage your permissions</h6>
            </div>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <Spin spinning={loading} size="large" tip="Loading..."> 
              <div className="table-top mb-0 pt-1">
                <div className="search-set">
                  <div className="search-input">
                    <a href="#" className="btn btn-searchset">
                      <i className="ti ti-search fs-14 feather-search" />
                    </a>
                    <div id="DataTables_Table_0_filter" className="dataTables_filter">
                      <label>
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="row mb-3">
                    <div className="col">
                      <label>Role:</label>
                      <select
                        className="form-select"
                        value={selectedRole}
                        onChange={(e) => {
                          setSelectedRole(e.target.value);
                        }}
                      >
                        {Object.keys(roleIdMap).map((role) => (
                          <option key={role} value={role}>
                            {role}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <table className="table datatable">
                <thead className="thead-light">
                  <tr>
                    <th>Menu</th>
                    <th>Operation</th>
                    {permissionTypes.map((perm) => (
                      <th key={perm.id}>{perm.label}</th>
                    ))}
                    <th>Allow All</th>
                  </tr>
                </thead>
                <tbody>
                  {menuData.map((item) => {
                    const allChecked = permissionTypes.every((perm) => permissions[item.id]?.[perm.id]);

                    return (
                      <tr key={item.id}>
                        <td>{item.menu}</td>
                        <td>{item.operation}</td>
                        {permissionTypes.map((perm) => (
                          <td key={perm.id}>
                            <div className="form-check form-check-md">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={permissions[item.id]?.[perm.id] || false}
                                onChange={() => handleCheckboxChange(item.id, perm.id)}
                              />
                            </div>
                          </td>
                        ))}
                        <td>
                          <div className="form-check form-check-md">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={allChecked}
                              onChange={(e) => handleAllowAllCheckbox(item.id, e.target.checked)}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {/* <div className="text-end mt-3">
                <button className="btn btn-primary" onClick={handleSavePermissions}>
                  Save
                </button>
              </div> */}
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetPermissions;